module.exports = __webpack_public_path__ + "static/portfolio_gallery_15-cb97d53fa2b97e1fb83b62b33423c1ed.jpg";